var assign = require('object-assign');
var EventEmitter = require('events').EventEmitter;

var AppDispatcher = require('../dispatchers/AppDispatcher');
var Constants = require('../constants/Constants');

function BaseStore (options) {
    this.options = assign({}, {
        defaultData: null,
        event: 'change'
    }, options);

    this.dispatcherCallbacks = {};

    this._setDefaultData();

    this._hasData = false;
    this._loading = false;

    this.appDispatch = AppDispatcher.register(this.handleDispatch.bind(this));
    this.register(Constants.store.CLEAR, this.clear);
}

assign(BaseStore.prototype, EventEmitter.prototype, {
    /**
     * Adds a callback that will be fired whenever the store emits an event.
     *
     * @param {function} callback
     */
    addChangeListener: function(callback) {
        this.on(this.options.event, callback);
    },

    /**
     * Can be run to clear all data in the store.
     */
    clear: function () {
        this._setDefaultData();
        this._hasData = false;
        this._loading = false;

        this.emitChange();
    },

    /**
     * Emits a change event.
     */
    emitChange: function() {
        this.emit(this.options.event);
    },

    /**
     * Marks the store as no longer loading and emits a change event.
     */
    finish: function () {
        this._loading = false;
        this.emitChange();
    },

    /**
     * Marks the store as finished and throws the passed error if the error has not
     * been previously handled.
     *
     * Allows the promise chain to continue to fail until the very end where this method
     * should be called to stop the error from bubbling up to the window.
     */
    finishWithErrors: function (err) {
        this.finish();

        if (!err.handled) {
            throw err;
        }
    },

    /**
     * Returns data the Store contains.
     */
    get: function () {
        return this._data;
    },

    /**
     * Main method that is called when the AppDispatcher is dispatching. Iterates over
     * any callbacks registered for the actionType and calls them.
     */
    handleDispatch: function (payload) {
        var action = payload.action;

        if (!this.dispatcherCallbacks.hasOwnProperty(action.actionType)) {
            return true;
        }

        var callbacks = this.dispatcherCallbacks[action.actionType];
        var changed = callbacks.filter(function (callback) {
            return callback.call(this, payload);
        }.bind(this));

        if (changed.length) {
            this.emitChange();
        }

        return true;
    },

    /**
     * Checks if the store has data or not.
     */
    has: function () {
        return this._hasData;
    },

    /**
     * Checks if the store is waiting on data from the dispatcher.
     */
    loading: function () {
        return this._loading;
    },

    /**
     * A function called from inside a promise that will break out of the promise and
     * emit a change from this store.
     */
    promiseChange: function (a) {
        setTimeout(this.emitChange.bind(this), 1);

        return a;
    },

    /**
     * Removes a callback from being fired when the store emits an event.
     */
    removeChangeListener: function(callback) {
        this.removeListener(this.options.event, callback);
    },

    /**
     * Registers a callback to be called whenever an action type constant is raised that
     * matches the supplied constant.
     */
    register: function(constant, callback) {
        if (!this.dispatcherCallbacks[constant]) {
            this.dispatcherCallbacks[constant] = [];
        }

        this.dispatcherCallbacks[constant].push(callback);
    },

    setData: function (data) {
        this._data = data;
        this._hasData = true;
    },

    _setDefaultData: function () {
        var data = this.options.defaultData;
        if (data !== null) {
            this._data = Array.isArray(this.options.defaultData) ?
                [ ...data ]:
                { ...data };
        } else {
            this._data = null;
        }
    }
});
module.exports = BaseStore;



// WEBPACK FOOTER //
// ./app/stores/BaseStore.js